import type { DateRange, FilterType, QueryFormatFilter } from '@hotjar/global-filters';
import type { QuantzProperty, QuantzOperation, QuantzLevel } from '@hotjar/quantz';

export interface TrendsConfig extends WithBasicQueryInfo, WithRenderInfo {}

export type ActionKind = 'heatmapLink' | 'recordingLink';

interface QueryInfo {
  groupBy?: QuantzProperty;
  limit?: number;
  windowed?: boolean;
  eventFilters?: QueryFormatFilter;
  eventType?: string;
  property?: QuantzProperty;
  operation: QuantzOperation;
  level?: QuantzLevel;
}

export interface WithBasicQueryInfo {
  queryInfo: QueryInfo;
}

export interface WithRenderInfo {
  renderInfo: {
    calculationType: CalculationType;
    chartType: ChartType;
  };
}

export enum CalculationType {
  percentage = 'percentage',
  raw = 'raw',
}

export enum ChartType {
  pie = 'pie',
  timeline = 'timeline',
  bar = 'bar',
  number = 'number',
}

export interface FilterChainSeries {
  key: string;
  filtersInUiFormat: FilterType[];
  color: string;
  label: string;
}

export interface TrendQuery {
  dateRange: DateRange;
  filterChainSeries: FilterChainSeries[];
  chartType: ChartType;
}
